var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon / Goal",
    clipPath: "url(#clip0_8917_107358)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.83398 7.99992C7.83398 7.63173 8.13246 7.33325 8.50065 7.33325C8.86884 7.33325 9.16732 7.63173 9.16732 7.99992C9.16732 8.36811 8.86884 8.66659 8.50065 8.66659C8.13246 8.66659 7.83398 8.36811 7.83398 7.99992Z",
    fill: "#1271A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1673 7.99992C16.1673 8.36811 15.8688 8.66659 15.5007 8.66659H15.1344C14.8217 11.8162 12.3169 14.321 9.16732 14.6337V14.9999C9.16732 15.3681 8.86884 15.6666 8.50065 15.6666C8.13246 15.6666 7.83398 15.3681 7.83398 14.9999V14.6337C4.68437 14.321 2.17961 11.8162 1.8669 8.66659H1.50065C1.13246 8.66659 0.833984 8.36811 0.833984 7.99992C0.833984 7.63173 1.13246 7.33325 1.50065 7.33325H1.8669C2.17961 4.18364 4.68437 1.67888 7.83398 1.36617V0.999919C7.83398 0.631729 8.13246 0.333252 8.50065 0.333252C8.86884 0.333252 9.16732 0.631729 9.16732 0.999919V1.36617C12.3169 1.67888 14.8217 4.18364 15.1344 7.33325H15.5007C15.8688 7.33325 16.1673 7.63173 16.1673 7.99992ZM5.83398 7.99992C5.83398 9.47268 7.02789 10.6666 8.50065 10.6666C9.97341 10.6666 11.1673 9.47268 11.1673 7.99992C11.1673 6.52716 9.97341 5.33325 8.50065 5.33325C7.02789 5.33325 5.83398 6.52716 5.83398 7.99992ZM9.16732 13.292C11.5798 12.9912 13.4919 11.0791 13.7927 8.66659H12.4453C12.1643 10.3416 10.8423 11.6636 9.16732 11.9446V13.292ZM3.20858 8.66659C3.50941 11.0791 5.42151 12.9912 7.83398 13.292V11.9446C6.15898 11.6636 4.83697 10.3416 4.55596 8.66659H3.20858ZM7.83398 2.70785C5.42151 3.00868 3.50941 4.92077 3.20858 7.33325H4.55596C4.83697 5.65825 6.15898 4.33624 7.83398 4.05522V2.70785ZM13.7927 7.33325C13.4919 4.92077 11.5798 3.00868 9.16732 2.70785V4.05522C10.8423 4.33624 12.1643 5.65825 12.4453 7.33325H13.7927Z",
    fill: "#1271A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.50065 8.66659C8.13246 8.66659 7.83398 8.36811 7.83398 7.99992C7.83398 7.63173 8.13246 7.33325 8.50065 7.33325C8.86884 7.33325 9.16732 7.63173 9.16732 7.99992C9.16732 8.36811 8.86884 8.66659 8.50065 8.66659Z",
    fill: "#1271A6"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8917_107358"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoal);
export default __webpack_public_path__ + "static/media/goal.ee39b32bcd7554bf7e685ff530fe43d4.svg";
export { ForwardRef as ReactComponent };